import React, { Suspense, useMemo } from 'react';
import dynamic from 'next/dynamic';

import { useTranslation } from '@lyearn/i18n';
import { Skeleton, Stack } from '@lyearn/ui';
import { TimezoneProps } from '@/components/Form/components/TimeZones/types';
import { timezones } from '@/utils/timezone/timezones';

const LazyTimezoneSelect = dynamic(
  () => import(/* webpackPreload: true */ /* webpackChunkName: "timezones" */ './Timezone'),
);

const style = {
  border: '1px solid #ccc',
  borderRadius: '8px',
  padding: '6px',
};

const TimezoneSelectorMobile = ({ value, setFieldValue, disabled, warnings }: TimezoneProps) => {
  const { t } = useTranslation();

  const selectedOption = useMemo(() => {
    return timezones.find((timezone) => timezone.tzCode === value) ?? null;
  }, [value]);

  return (
    <Stack className="mt-4 mb-16" direction="col">
      <Stack className="truncate" style={style}>
        <Suspense
          fallback={<Skeleton animation="wave" height={24} variant="rectangular" width="100%" />}>
          <LazyTimezoneSelect
            disabled={disabled}
            setFieldValue={setFieldValue}
            value={selectedOption ? selectedOption.tzCode : ''}
          />
        </Suspense>
      </Stack>
    </Stack>
  );
};

export default TimezoneSelectorMobile;
